import CoverageAnalyzer from './CoverageAnalyzer'

export default CoverageAnalyzer
